export default [
  {
    name: 'Bounties',
    tag: 'Bounties',
    link: '/bounties',
  },
  {
    name: 'Contests',
    tag: 'Contests',
    link: '/contests',
  },
  {
    name: 'Reports',
    tag: 'Reports',
    link: '/reports',
  },
  {
    name: 'WhiteHats',
    tag: 'whiteHats',
    link: '/whiteHats',
  },
  {
    name: 'Whitehat Teams',
    tag: 'Whitehat Teams',
    link: '/whitehat-teams',
  },
  // {
  //   name: 'Articles',
  //   tag: 'articles',
  //   link: '/articles',
  // },
  {
    name: 'About',
    tag: 'About',
    link: '/about',
  },
];
